import { DataGridEmptyStateCopy, DataGridEmptyStateType } from './types';

export const DATA_GRID_ROW_HEADER_COLUMN_ID = 'dataGridRowHeader';

export const DATA_GRID_ROW_HEADER_WIDTH = 240;

export const DATA_GRID_DEFAULT_COLUMN_WIDTH = 200;

export const DATA_GRID_ROW_HEIGHT = 44;

export const DATA_GRID_HEADER_BAND_HEIGHT = 40;

export const DATA_GRID_INDENT_STEP = 16;

export const DATA_GRID_DEFAULT_LOADING_ROWS = 10;

export const DATA_GRID_DEFAULT_EMPTY_TITLE = 'No results found';

export const DATA_GRID_DEFAULT_EMPTY_DESCRIPTION =
  'Try adjusting your filters or search terms';

export const DATA_GRID_DEFAULT_SEARCH_PLACEHOLDER = 'Search';

export const DATA_GRID_DEFAULT_FILTERS_LABEL = 'Filters';

export const DATA_GRID_DEFAULT_SORT_LABEL = 'Sort';

export const DATA_GRID_DEFAULT_GROUP_LABEL = 'Group';

export const DATA_GRID_DEFAULT_SETTINGS_LABEL = 'Table settings';

export const DATA_GRID_DEFAULT_EXPAND_LABEL = 'Expand row';

export const DATA_GRID_DEFAULT_COLLAPSE_LABEL = 'Collapse row';

export const DATA_GRID_EMPTY_STATE_COPY: Record<
  DataGridEmptyStateType,
  DataGridEmptyStateCopy
> = {
  unpopulated: {
    title: 'No results to show.',
    description: 'Uploaded transactions will appear here.',
  },
  filtersApplied: {
    title: 'No transactions found',
    description:
      "We couldn't find any transactions matching your current filters. Review your selections, or reset filters.",
  },
  searchApplied: {
    title: 'No transactions found',
    description: 'Your search did not match any result. Please try again.',
  },
  searchAndFiltersApplied: {
    title: 'No transactions found',
    description:
      "Your current search terms didn't return any results within these filters. Try refining your search term, adjusting the filters, or reset both.",
  },
};

export const DATA_GRID_CELL_MAX_VISIBLE_BADGES = 3;

export const DATA_GRID_CELL_MAX_VISIBLE_AVATARS = 3;

export const DATA_GRID_CELL_MASK_LENGTH = 8;
